import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGetActiveAnnouncementsQuery } from "../services/Api";
import { X } from "lucide-react";

const AnnouncementPopup = () => {
  const location = useLocation();
  const { data: announcementData } = useGetActiveAnnouncementsQuery();
  const [isVisible, setIsVisible] = useState(false);
  const [currentAnnouncement, setCurrentAnnouncement] = useState(null);

  useEffect(() => {
    // Only show popup on home page
    if (location.pathname === "/home") {
      if (announcementData?.status && announcementData?.data?.length > 0) {
        const firstAnnouncement = announcementData.data[0];
        setCurrentAnnouncement(firstAnnouncement);
        setIsVisible(true);
      }
    } else {
      setIsVisible(false);
    }
  }, [announcementData, location.pathname]);

  const handleClose = () => {
    setIsVisible(false);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };

  if (!isVisible || !currentAnnouncement) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.55)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px"
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "16px",
          padding: "32px",
          maxWidth: "480px",
          width: "100%",
          position: "relative",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.18)",
          textAlign: "center"
        }}
      >
        {/* Close Button */}
        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            background: "#f0f0f0",
            border: "none",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            fontSize: "18px",
            cursor: "pointer",
            color: "#555",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0
          }}
        >
          <X size={18} />
        </button>

        {/* Title */}
        <h2
          style={{
            fontSize: "22px",
            fontWeight: 700,
            color: "#2d2d2d",
            marginBottom: "12px",
            marginTop: 0
          }}
        >
          {currentAnnouncement.title}
        </h2>

        {/* Message */}
        <p
          style={{
            fontSize: "15px",
            color: "#555",
            lineHeight: 1.6,
            marginBottom: "24px",
            marginTop: "12px"
          }}
        >
          {currentAnnouncement.message}
        </p>

        {/* Date Info */}
        {currentAnnouncement.expiry_date && (
          <p
            style={{
              fontSize: "12px",
              color: "#999",
              marginBottom: "16px",
              marginTop: 0
            }}
          >
            Valid until: {formatDate(currentAnnouncement.expiry_date)}
          </p>
        )}

        {/* OK Button */}
        <button
          onClick={handleClose}
          style={{
            background: "#6c63ff",
            color: "white",
            border: "none",
            borderRadius: "10px",
            padding: "10px 32px",
            fontSize: "15px",
            fontWeight: 600,
            cursor: "pointer",
            width: "100%",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#5a52d5")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#6c63ff")}
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default AnnouncementPopup;
